import React, { useState } from 'react';
import { ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP, ELECTRICITY_AGREEMENT_RENEWAL_PLAN_TYPE_MAP, ElectricityAgreementRenewalPlanFilters, ElectricityAgreementRenewalPlanStatus, ElectricityAgreementRenewalPlanType } from './models';
import Select from 'react-select';
import DatePicker from 'react-date-picker';
import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar.svg';
import { ReactComponent as ClearIcon } from '../../assets/icons/close.svg';
import { SelectOption } from 'common/common-models';
import { ElectricityPackageType, IElectricityPackage } from 'components/ElectricityPackages/models';

interface ElectricityAgreementRenewalPlansSearchBarProps {
    filters: ElectricityAgreementRenewalPlanFilters;
    onFilter: (filter: ElectricityAgreementRenewalPlanFilters) => void;
    onPeriodChange: (periodStart?: string, periodEnd?: string) => void;
    packages: IElectricityPackage[];
}

const selectStyle = {
    indicatorSeparator: () => (
        {
            backgroundColor: 'red',
            width: '50px',
        }
    ),
};

const statuses = [
    { value: ElectricityAgreementRenewalPlanStatus.PLANNED, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.PLANNED] },
    { value: ElectricityAgreementRenewalPlanStatus.INCOMPLETE, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.INCOMPLETE] },
    { value: ElectricityAgreementRenewalPlanStatus.PENDING, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.PENDING] },
    { value: ElectricityAgreementRenewalPlanStatus.CANCELED, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.CANCELED] },
    { value: ElectricityAgreementRenewalPlanStatus.ACCEPTED, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.ACCEPTED] },
    { value: ElectricityAgreementRenewalPlanStatus.REJECTED, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.REJECTED] },
    { value: ElectricityAgreementRenewalPlanStatus.AUTO_ACCEPTED, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_STATUS_MAP[ElectricityAgreementRenewalPlanStatus.AUTO_ACCEPTED] },
];

const types = [
    { value: ElectricityAgreementRenewalPlanType.RENEWAL, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_TYPE_MAP[ElectricityAgreementRenewalPlanType.RENEWAL] },
    { value: ElectricityAgreementRenewalPlanType.PROCUREMENT, label: ELECTRICITY_AGREEMENT_RENEWAL_PLAN_TYPE_MAP[ElectricityAgreementRenewalPlanType.PROCUREMENT] },
];

export const ElectricityAgreementRenewalPlansSearchBar = (props: ElectricityAgreementRenewalPlansSearchBarProps) => {
    const [periodStart, setPeriodStart] = useState<string>();
    const [periodEnd, setPeriodEnd] = useState<string>();

    const onInputChange = (inputEvent: any) => {
        props.onFilter({
            searchQuery: inputEvent.target.value
        });
    };

    const onStatusChange = (value: any) => {
        props.onFilter({
            status: value?.value
        });
    }

    const onTypeChange = (value: any) => {
        props.onFilter({
            type: value?.value
        });
    }

    const onPackageChange = (value: any) => {
        props.onFilter({
            publicPackageId: value?.value
        });
    }

    const onPeriodChange = (periodStart?: string, periodEnd?: string) => {
        setPeriodStart(periodStart);
        setPeriodEnd(periodEnd);
        props.onPeriodChange(periodStart, periodEnd);
    }

    const packageOptions : SelectOption<number>[] | undefined = props.packages
        .filter(p => p.type === ElectricityPackageType.CONSUMPTION)
        .map(p => ({ value: p.publicId, label: p.nameEt }))
        .sort((a, b) => a.value - b.value);
    const currentPackageOption = packageOptions?.find(p => p.value === props.filters.publicPackageId);

    return (
        <div className="bar-position">
            <h2 className="text-light">
                Elektrilepingu pikendusplaanid
            </h2>
            <div className="card mb-3 shadow">
                <div className="card-body">
                    <div className="d-flex flex-wrap flex-sm-nowrap justify-content-between">
                        <div className='d-flex'>
                            <input
                                placeholder="Lepingu number"
                                className='search-bar__input p-2'
                                onChange={onInputChange}
                            value={props.filters.searchQuery || ''}
                            />
                            <Select
                                style={selectStyle}
                                className='mw-160-px mr-2 customer-status__select'
                                value={statuses.find(s => s.value === props.filters.status) || null}
                                onChange={onStatusChange}
                                options={statuses}
                                isClearable
                                placeholder='Vali staatus'
                            />
                            <Select
                                style={selectStyle}
                                className='mw-160-px mr-2 customer-status__select'
                                value={types.find(s => s.value === props.filters.type) || null}
                                onChange={onTypeChange}
                                options={types}
                                isClearable
                                placeholder='Vali tüüp'
                            />
                            <Select
                                className='w-18-rem mr-2 customer-status__select'
                                value={currentPackageOption || null}
                                onChange={onPackageChange}
                                options={packageOptions}
                                isClearable
                                placeholder='Vali pakett'
                            />
                        </div>
                        <div className='d-flex flex-column flex-xl-row'>
                            <DatePicker
                                className="mr-2 mb-2 mb-xl-0"
                                value={periodStart ? new Date(periodStart) : null}
                                locale='et'
                                clearIcon={<ClearIcon />}
                                calendarIcon={<CalendarIcon />}
                                format='dd.MM.yyyy'
                                onChange={(event: any) => {
                                    if(!event){
                                        onPeriodChange(undefined, periodEnd)
                                        return;
                                    }

                                    onPeriodChange(new Date(event).toString(), periodEnd)
                                }}
                            />
                            <DatePicker
                                value={periodEnd ? new Date(periodEnd) : null}
                                locale='et'
                                clearIcon={<ClearIcon />}
                                calendarIcon={<CalendarIcon />}
                                format='dd.MM.yyyy'
                                onChange={(event: any) => {
                                    if(!event){
                                        onPeriodChange(periodStart, undefined)
                                        return;
                                    }

                                    onPeriodChange(periodStart, new Date(event).toString())
                                }}
                            />
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    )
}